import type { PlayEvent } from '@/api/types'
import { formatDate, formatDuration } from '@/lib/format'

export const SOURCE_LABELS: Record<PlayEvent['source'], string> = {
  daylist: 'Daylist',
  library: 'Library',
  album: 'Album',
  playlist: 'Playlist',
  search: 'Search',
  shuffle: 'Shuffle',
  queue: 'Queue',
  unknown: '',
}

/** Day plus time of day. When you listened to something is half of what makes a
 *  listening log recognisable — "Tuesday evening" is how people remember music. */
export function when(iso: string): string {
  const time = new Date(iso).toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  })
  return `${formatDate(iso)} · ${time}`
}

/**
 * How the listen went, without claiming more than is known.
 *
 * Deliberately not the word "skipped". A listen interrupted by closing the tab
 * looks identical in the data to one the listener chose to skip, and calling both
 * a skip puts an intention on record that was never observed. The position says
 * the same useful thing and only asserts what was actually seen.
 */
export function progress(event: PlayEvent): string {
  if (event.completed) return ''
  // Shown even when the duration is unknown. `completed` is what says whether it
  // finished, and a row that stayed silent because the duration was missing read
  // exactly like one that played to the end.
  return `stopped at ${formatDuration(Math.round(event.position_ms / 1000))}`
}
